import styled from "styled-components";
import { useState, useEffect } from "react";
import FormDatePicker from "../../../../../../components/FormControls/FormDatePicker";
import PrimaryButton from "../../../../../../components/FormControls/PrimaryButton";
import SecondaryButton from "../../../../../../components/FormControls/SecondaryButton";
import WarningButton from "../../../../../../components/FormControls/WarningButton";
import request from "../../../../../../api/request";
import MessageBox from "../../../../../../components/MessageBox";
import NarrowGrid from "../../../../../../components/NarrowGrid";
import { NotificationManager } from 'react-notifications';
import FormSelectWithLabel from "../../../../../../components/FormControls/FormSelectWithLabel";

const StyledBranchFinancialYearSettings = styled.div`
`;

const WhiteBoard = styled.div`
    background-color: white;
    width: 600px;
    box-sizing: border-box;
    min-height: 543px;
    padding: 30px;
    margin-bottom: 30px;
    color: ${(props) => props.theme.color.gray};
`;

const Title = styled.span`
    display: block;
    color: ${(props) => props.theme.color.primaryblue};
    font-size: 14px;
    font-weight: 600;
    padding-bottom: 5px;
`;

function BranchFinancialYearSettings(props) {

    let currentYear = new Date().getFullYear();

    let years = [];
    for (let i = currentYear - 10; i < currentYear + 5; i ++) {
        years.push(i);
    }

    const {selectedBranch, isAddBranchMode, setIsAddBranchMode, refreshBranchesCallback} = props;

    const [loadedPage, setLoadedPage] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isDeletingBranch, setIsDeletingBranch] = useState(false);
    const [isDeletingFinancialYear, setIsDeletingFinancialYear] = useState(false);
    const [financialYears, setFinancialYears] = useState([]);
    const [selectedFinancialYear, setSelectedFinancialYear] = useState(null);
    const [selectedFinancialYearId, setSelectedFinancialYearId] = useState(null);
    const [isAddFinancialYearMode, setIsAddFinancialYearMode] = useState(false);
    const [gridColumns, setGridColumns] = useState([
        {id: 'Year', type: 'String', width: 60, textAlign: 'left'},
        {id: 'From', type: 'String', width: 80, textAlign: 'center'},
        {id: 'To', type: 'String', width: 80, textAlign: 'center'},
    ]);
    const [gridData, setGridData] = useState({groups: [''], items: [[]]});
    const [year, setYear] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [showMessageBox, setShowMessageBox] = useState(false);
    const [needsValidation, setNeedsValidation] = useState(false);
    const [isAddingDuplicatedFinancialYear, setIsAddingDuplicatedFinancialYear] = useState(false);

    const convertDateToUTCTimeZone = (val) => {
        let diffMinutes = val.getTimezoneOffset();
        val.setTime(val.getTime() - diffMinutes*60*1000);
        return val;
    }

    const onSelectGridItem = (item) => {
        setSelectedFinancialYearId(item.Id);
        setSelectedFinancialYear(item);
        setYear(parseInt(item.Year));
    }
    
    const fetchBranchFinancialYears = async (branchCommitteeCodeToSelect, accountingYear) => {
        try {
            let financialYearList = [];

            const resp = (await request('database', 'fetchBranchFinancialYears'));
            if (resp.ok) {
                resp.data.map((financialYear, index) => {
                    financialYearList.push(financialYear);
                });
                setFinancialYears(financialYearList);
                rebuildGridData(financialYearList, branchCommitteeCodeToSelect, accountingYear);
            } else {
                console.log(resp.data);
                NotificationManager.error(resp.data);
                return false;
            }
        } catch (e) {
            console.log('Failed to fetch financial years: ', e);
            return false;
        }
        return true;
    }

    const onDeleteFinancialYear = async () => {
        if (selectedFinancialYear) {
            setIsDeletingFinancialYear(true);
            let deleteData = {};
            deleteData.RecordType = selectedBranch.RecordType;
            deleteData.BranchCommitteeCode = selectedBranch.BranchCommitteeCode;
            deleteData.DivisionCode = selectedBranch.DivisionCode;
            deleteData.AccountingYear = year;

            const resp = (await request('database', 'deleteBranchFinancialYear', [deleteData]));
            if (resp.ok) {
                setSelectedFinancialYear(null);
                setSelectedFinancialYearId(null);
                fetchBranchFinancialYears(selectedBranch.BranchCommitteeCode, selectedFinancialYear ? parseInt(selectedFinancialYear.Year) : null);
                NotificationManager.success('Successfully deleted branch financial year');
            } else
            {
                console.log(resp.data);
                NotificationManager.error(resp.data);
            }
            setIsDeletingFinancialYear(false);
        }
    }

    const onSaveChanges = async () => {
        if (isAddFinancialYearMode) { // adding new item
            if (year === '' || startDate === null || endDate === null) {
                setNeedsValidation(true);
            } else {
                // check duplicated code
                if (gridData.items[0].length > 0 && (gridData.items[0].find((itm) => itm.Year === year.toString()))) {
                    setIsAddingDuplicatedFinancialYear(true);
                } else {
                    setIsSaving(true);
                    let saveData = {};
                    saveData.RecordType = selectedBranch.RecordType;
                    saveData.BranchCommitteeCode = selectedBranch.BranchCommitteeCode;
                    saveData.DivisionCode = selectedBranch.DivisionCode;
                    saveData.AccountingYear = year;
                    saveData.StartDate = convertDateToUTCTimeZone(startDate);
                    saveData.EndDate = convertDateToUTCTimeZone(endDate);

                    const resp = (await request('database', 'addBranchFinancialYear', [saveData]));
                    if (resp.ok) {
                        fetchBranchFinancialYears(selectedBranch.BranchCommitteeCode, year);
                        NotificationManager.success('Successfully added branch financial year');
                    } else
                    {
                        console.log(resp.data);
                        NotificationManager.error(resp.data);
                    }
                    setIsSaving(false);
                    setIsAddFinancialYearMode(false);
                }
            }
        } else {
            if (selectedFinancialYear && (startDate === null || endDate === null)) {
                setNeedsValidation(true);
            } else {
                // check duplicated code
                setIsSaving(true);
                let saveData = {};
                saveData.RecordType = selectedBranch.RecordType;
                saveData.BranchCommitteeCode = selectedBranch.BranchCommitteeCode;
                saveData.DivisionCode = selectedBranch.DivisionCode;
                saveData.AccountingYear = parseInt(selectedFinancialYear.Year);
                saveData.StartDate = convertDateToUTCTimeZone(startDate);
                saveData.EndDate = convertDateToUTCTimeZone(endDate);

                const resp = (await request('database', 'updateBranchFinancialYear', [saveData]));
                if (resp.ok) {
                    fetchBranchFinancialYears(selectedBranch.BranchCommitteeCode, selectedFinancialYear ? parseInt(selectedFinancialYear.Year) : null);
                    NotificationManager.success('Successfully updated branch financial year');
                } else
                {
                    console.log(resp.data);
                    NotificationManager.error(resp.data);
                }
                setIsSaving(false);
            }
        }
    }

    const deleteBranch = async () => {
        setShowMessageBox(false);

        setIsDeletingBranch(true);
        let deleteData = {};
        deleteData.RecordType = selectedBranch.RecordType;
        deleteData.RecordName = selectedBranch.RecordName;
        deleteData.BranchCommitteeCode = selectedBranch.BranchCommitteeCode;
        const resp = (await request('database', 'deleteBranch', [deleteData]));
        if (resp.ok && refreshBranchesCallback) {
            refreshBranchesCallback();
            NotificationManager.success('Branch deleted');
        } else
        {
            console.log(resp.data);
            NotificationManager.error(resp.data);
        }
        setIsDeletingBranch(false);
    }

    const onChangeStartDate = (val) => {
        setStartDate(val);
    }

    const onChangeEndDate = (val) => {
        setEndDate(val);
    }

    const dateToStr = (date) => {
        function pad(s) { return (s < 10) ? '0' + s : s; };
        let ret = [pad(date.getDate()), pad(date.getMonth()+1), date.getFullYear()].join('/');
        return ret;
    }

    const strToDate = (str) => {
        var date_components = str.split("/");
        var day = date_components[0];
        var month = date_components[1];
        var year = date_components[2];
        return new Date(year, month - 1, day);
    }

    const rebuildGridData = (financialYears, branchCommitteeCodeToSelect, accountingYearToSelect) => {
        if (financialYears && selectedBranch && financialYears.length > 0) {
            let financialYearList = [];
            financialYears.map((financialYear, index) => {
                if (financialYear.RecordType === selectedBranch.RecordType && financialYear.BranchCommitteeCode === selectedBranch.BranchCommitteeCode && financialYear.DivisionCode === selectedBranch.DivisionCode) {
                    let gridItem = {Id: index, Year: financialYear.AccountingYear.toString(), From: dateToStr(new Date(financialYear.StartDate)), To: dateToStr(new Date(financialYear.EndDate))};
                    financialYearList.push(gridItem);
                    if (branchCommitteeCodeToSelect && accountingYearToSelect && financialYear.BranchCommitteeCode === branchCommitteeCodeToSelect && financialYear.AccountingYear === accountingYearToSelect) {
                        setSelectedFinancialYearId(index);
                        setSelectedFinancialYear(gridItem);
                    }
                }
            });
            setGridData({groups: [''], items: [financialYearList]});
        }
    }

    useEffect(() => {
        if (!loadedPage) {
            fetchBranchFinancialYears();
            setLoadedPage(true);
        }
        rebuildGridData(financialYears);
        setSelectedFinancialYear(null);
        setSelectedFinancialYearId(null);
        setYear(currentYear);
        setStartDate(null);
        setEndDate(null);
        setNeedsValidation(false);
    }, [selectedBranch]);

    useEffect(() => {
        if (isAddFinancialYearMode) {
            setNeedsValidation(false);
            setYear(currentYear);
            setStartDate(null);
            setEndDate(null);
        } else if (selectedFinancialYear) {
            setNeedsValidation(false);
            setYear(parseInt(selectedFinancialYear.Year) ? parseInt(selectedFinancialYear.Year) : currentYear);
            setStartDate(selectedFinancialYear.From ? strToDate(selectedFinancialYear.From) : null);
            setEndDate(selectedFinancialYear.To ? strToDate(selectedFinancialYear.To) : null);
        }
    }, [isAddFinancialYearMode]);

    useEffect(() => {
        if (selectedFinancialYear) {
            setYear(parseInt(selectedFinancialYear.Year) ? parseInt(selectedFinancialYear.Year) : currentYear);
            setStartDate(selectedFinancialYear.From ? strToDate(selectedFinancialYear.From) : null);
            setEndDate(selectedFinancialYear.To ? strToDate(selectedFinancialYear.To) : null);
        } else {
            setYear(currentYear);
            setStartDate(null);
            setEndDate(null);
        }
    }, [selectedFinancialYear]);

    useEffect(() => {
        setIsAddingDuplicatedFinancialYear(false);
        setNeedsValidation(false);
    }, [selectedBranch, selectedFinancialYear, isAddFinancialYearMode, year, startDate]);

    return (
        <StyledBranchFinancialYearSettings>
            <WhiteBoard>
                <Title>Financial Year</Title>
                <div style={{display:'flex'}}>
                    <div>
                        <NarrowGrid id='branchsetting_financialyears_grid' gridColumns={gridColumns} gridData={gridData} disabled={isAddFinancialYearMode} itemIdToSelect={selectedFinancialYearId} onSelectGridItem={onSelectGridItem} gridStyle={{width:220, height:350, marginTop:20}}></NarrowGrid>
                        <div style={{marginTop:20}}>
                            {selectedFinancialYearId !== null && !isAddFinancialYearMode && <SecondaryButton caption='Delete' isLoading={isDeletingFinancialYear} onClick={() => onDeleteFinancialYear()} style={{width:75, height:25}}></SecondaryButton>}
                            {isAddFinancialYearMode && <SecondaryButton caption='Cancel' onClick={() => setIsAddFinancialYearMode(false)} style={{width:75, height:25, float:'right'}}></SecondaryButton>}
                            {!isAddFinancialYearMode && <PrimaryButton caption='Create new' onClick={() => setIsAddFinancialYearMode(true)} style={{width:100, height:25, float:'right'}}></PrimaryButton>}
                        </div>
                    </div>
                    <div style={{marginLeft:30}}>
                    <FormSelectWithLabel label='Year' items={years} value={year} disabled={!isAddFinancialYearMode} onChange={(e) => setYear(parseInt(e.target.value))} style={{width:150, height:35, paddingLeft:13}}></FormSelectWithLabel>
                    {isAddingDuplicatedFinancialYear && <div style={{marginTop:5, width:280, fontSize:12, fontWeight:700, color:'#dc3545'}}>* Accounting year is duplicated.</div>}
                    <FormDatePicker label='From' value={startDate} onChange={(val) => onChangeStartDate(val)} style={{width:280}} validated={needsValidation && startDate === null ? false : undefined} disabled={selectedFinancialYearId === null && !isAddFinancialYearMode} ></FormDatePicker>
                    <FormDatePicker label='To' value={endDate} onChange={(val) => onChangeEndDate(val)} style={{width:280}} validated={needsValidation && endDate === null ? false : undefined} disabled={selectedFinancialYearId === null && !isAddFinancialYearMode} ></FormDatePicker>
                    </div>
                </div>
            </WhiteBoard>
            <div>
                {!isAddBranchMode && <WarningButton caption='Delete branch' isLoading={isDeletingBranch} onClick={() => setShowMessageBox(true)} style={{width:120}}></WarningButton>}
                {isAddBranchMode && <SecondaryButton caption='Cancel' onClick={() => setShowMessageBox(true)} style={{width:100}}></SecondaryButton>}
                <PrimaryButton caption={isAddFinancialYearMode ? 'Add financial year' : 'Save changes'} isLoading={isSaving} onClick={() => onSaveChanges()} disabled={isAddFinancialYearMode || selectedFinancialYear ? false : true} style={{width:150, float:'right'}}></PrimaryButton>
            </div>

            { showMessageBox && <MessageBox
                text = {isAddBranchMode ? 'Are you sure cancel?' : 'Are you sure you want to delete this branch?'}
                yesText = {isAddBranchMode ? 'Cancel' : 'Delete branch'}
                noText = {isAddBranchMode ? 'No' : 'Cancel'}
                isWarning = {!isAddBranchMode}
                handleClickYes = {() => {
                        if (isAddBranchMode) {
                            if (setIsAddBranchMode) {
                                setIsAddBranchMode(false);
                                setShowMessageBox(false);
                            }
                        } else {
                            deleteBranch();
                        }
                    }
                }
                handleClickNo = {() => setShowMessageBox(false)}
            />}
        </StyledBranchFinancialYearSettings>
    )
}

export default BranchFinancialYearSettings;